// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';
import { selectProgress, selectPropertyOwner, selectTotalOrdersSum } from '../../feature';

// Modules
import { StepTag } from '@/modules/Properties';

// Components
import {
  StyledCell,
  StyledContainer,
  StyledRow,
  StyledStepsWrap,
  StyledText,
  StyledTitle,
} from './GeneralInformationContainerStyles';
import { StyledLabel, StyledLink } from '../../components';

// Models
import { ROUTES } from '@/models/router.model';

const GeneralInformationContainer = () => {
  const { t } = useTranslation('property');
  const totalOrderSum = useAppState(selectTotalOrdersSum);
  const propertyOwner = useAppState(selectPropertyOwner);
  const progress = useAppState(selectProgress);

  return (
    <StyledContainer>
      <StyledTitle>{t('title_general_info')}</StyledTitle>
      <StyledRow>
        <StyledCell>
          <StyledLabel>{t('label_steps_completed')}</StyledLabel>
          <StyledStepsWrap>
            {progress?.map((step, idx) => (
              <StepTag key={step.step_name} number={idx + 1} status={step.status} />
            ))}
          </StyledStepsWrap>
        </StyledCell>
        <StyledCell>
          <StyledLabel>{t('label_sum_orders')}</StyledLabel>
          <StyledText>{totalOrderSum}</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledLabel>{t('label_owner_name')}</StyledLabel>
          <StyledLink
            path={{
              pathname: ROUTES.USERS,
              search: new URLSearchParams({ id: propertyOwner?.user_id ?? '' }).toString(),
            }}
          >
            {propertyOwner?.full_name ?? '-'}
          </StyledLink>
        </StyledCell>
        <StyledCell>
          <StyledLabel>{t('label_owner_email')}</StyledLabel>
          <StyledText>{propertyOwner?.email ?? '-'}</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledLabel>{t('label_owner_phone')}</StyledLabel>
          <StyledText>{propertyOwner?.phone_number ?? '-'}</StyledText>
        </StyledCell>
      </StyledRow>
    </StyledContainer>
  );
};

export default GeneralInformationContainer;
